


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
@Component
export default class Grid extends Vue {
  @Prop({ required: true }) public items: any[]
  @Prop({ default: 500 }) public minWidth: number
  @Prop({ default: false }) public animated: boolean
  @Prop() public order: number[]

  public width: number = 0
  public height: number = 0
  public active: boolean[] = []

  /**
   * Update size.
   */
  setWidthAndHeight() {
    const { width, height } = this.$el.getBoundingClientRect()
    const { length } = this.items
    if (width && height) {
      this.width =
        width / Math.ceil(width / Math.max(this.minWidth, width / length))
      this.height = height / Math.ceil(length / (width / this.width))
    }
  }
  /**
   * Animate.
   */
  public animate() {
    if (this.animated) {
      if (this.order) {
        this.order.forEach((value, i) => {
          setTimeout(() => {
            this.$set(this.active, value, true)
          }, i * 1000)
        })
      } else {
        this.items.forEach((item, index) => {
          setTimeout(() => {
            this.$set(this.active, index, true)
          }, index * 1000)
        })
      }
    }
  }
  /**
   * On mounted hook
   */
  mounted() {
    this.animate()
    this.setWidthAndHeight()
    window.addEventListener('resize', this.setWidthAndHeight.bind(this))
  }
}
